import React, { useState } from "react";
import "./KnowledgeBasis.scss";
import CreateFirstKnowlegde from "./CreateFirstKnowlegde/CreateFirstKnowlegde";
import KnowledgeBaseList from "./KnowledgeBaseList/KnowledgeBaseList";
import Newknowledge from "./knowledgeComponents/Newknowlegde/Newknowledge";

export const SharedDataContext = React.createContext();

const KnowledgeBasis = ({ active, setActive }) => {
  const [activeTab, setActivetab] = useState("createFirstKnowledge");
  const [sharedData, setSharedData] = useState(null);

  const handleActiveTab = (tab) => {
    setActivetab(tab);
  };

  console.log("sharedData :", sharedData);

  return (
    <div>
      <SharedDataContext.Provider value={{ sharedData, setSharedData }}>
        <div className="knowledgeBasis-main-container">
          {activeTab === "createFirstKnowledge" && <CreateFirstKnowlegde />}
          {activeTab === "newKnowledge" && <Newknowledge />}
          {activeTab === "newKnowledge" && <KnowledgeBaseList />}
        </div>
      </SharedDataContext.Provider>
    </div>
  );
};

export default KnowledgeBasis;
